/** Gruppi di visualizzazione, distinti dai legami genealogici. */
export const familyGroups = [
  ['', 'Automatico, dai legami conosciuti'],
  ['nonni', 'Nonni e bisnonni'],
  ['genitori', 'Genitori, zii e zie'],
  ['generazione', 'La mia generazione: fratelli e cugini'],
  ['figli', 'Figli e nipoti'],
  ['altri', 'Altre persone care'],
] as const;
